/* Zio Galeri — tema quick-view elementinden türetilen gallery-view.
   Tema JS'ine dokunulmaz: sınıf customElements.get ile alınıp genişletilir.
   QuickView.quickview()'dan tek fark: fetch adresi ?view=modal eklenmeden
   data-product-url'in kendisidir (metaobject sayfası .quick-view__content döndürür)
   ve ürün formu olmadığı için Shopify.PaymentButton çağrısı yoktur. */
(function () {
  customElements.whenDefined('quick-view').then(function () {
    if (customElements.get('gallery-view')) return;

    const QuickView = customElements.get('quick-view');

    class GalleryView extends QuickView {
      quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionUrl = this.getAttribute('data-product-url').split('?')[0];

        this.quickviewAbortController?.abort();
        this.quickviewAbortController = new AbortController();
        const { signal } = this.quickviewAbortController;

        fetch(sectionUrl, { signal })
          .then((response) => response.text())
          .then((responseText) => {
            setTimeout(() => {
              if (signal.aborted) return;

              const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
              const scope = parsedHTML.getElementById('MainContent') || parsedHTML;
              const contentElement = scope.querySelector(this.selector);

              if (!contentElement) {
                console.error('[GalleryView] Missing content in response:', sectionUrl);
                this.hide();
                return;
              }

              this.setInnerHTML(drawerContent, contentElement.innerHTML);
              theme.a11y.trapFocus(this, this.focusElement);

              document.dispatchEvent(new CustomEvent('quickview:loaded', {
                detail: {
                  productUrl: this.getAttribute('data-product-url')
                }
              }));
            }, 200);
          })
          .catch((e) => {
            if (e.name !== 'AbortError') console.error(e);
          });
      }
    }

    customElements.define('gallery-view', GalleryView);
  });
})();
